"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TimingEvent_logger, _TimingEvent_name, _TimingEvent_eventObject, _TimingEvent_metadata, _TimingEvent_loggingFunction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimingEvent = exports.addStage = void 0;
const destination_1 = require("./destination");
const startHrTime = Symbol("start");
exports.addStage = Symbol("addstage");
let containerState = "cold";
const millis = (hrtime) => {
    const nanoseconds = (hrtime[0] * 1e9) + hrtime[1];
    return nanoseconds / 1e6;
};
const millisSince = (start) => {
    return millis(process.hrtime(start));
};
/**
 * @param logger - print function
 * @param name
 * @param identity - data that identifies the request and should be present in start AND end events
 * @param metadata - data for the start event for <b>ALL</b> destinations
 * @param {object} loggingFunction - optional function to log a single record (receives a string, returns void). If not passed, records will be logged to console
 * @constructor
 */
class TimingEvent {
    constructor(logger, name, eventObject, metadata, loggingFunction) {
        _TimingEvent_logger.set(this, void 0);
        _TimingEvent_name.set(this, void 0);
        _TimingEvent_eventObject.set(this, void 0);
        _TimingEvent_metadata.set(this, void 0);
        _TimingEvent_loggingFunction.set(this, void 0);
        __classPrivateFieldSet(this, _TimingEvent_logger, logger, "f");
        __classPrivateFieldSet(this, _TimingEvent_name, name, "f");
        __classPrivateFieldSet(this, _TimingEvent_eventObject, eventObject, "f");
        __classPrivateFieldSet(this, _TimingEvent_metadata, metadata, "f");
        __classPrivateFieldSet(this, _TimingEvent_loggingFunction, loggingFunction, "f");
        this.destinations = (0, destination_1.all)();
        this.timingStart = process.hrtime();
        const startMillis = millis(this.timingStart);
        this.destinations.forEach(destination => {
            // (init) assign each with identity data and stages
            destination.data = Object.assign(Object.assign({}, destination.data), eventObject);
            // log the start event immediately
            logger(Object.assign(Object.assign({ event: name + "-start", component: name, start: startMillis, containerState: containerState }, destination.data), metadata), destination, loggingFunction);
        });
        containerState = "warm";
    }
    /**
     * Starts a stage within the event given the stage name, metadata and destination
     * @param {string} stageName - The stage name
     * @param {object} stageMetadata - optional Json object representing additional data for the stage
     * @param {DESTINATION} stageDestination - optional The destination of the stage
     * @default if destination is not present defaults to DESTINATION.All
     * @return {Stage} a stage object to be closed by calling end
     */
    startStage(stageName, stageMetadata, stageDestination = "ALL" /* DESTINATION.ALL */) {
        const now = process.hrtime();
        const millisSinceStart = millisSince(this.timingStart);
        this.destinations.filter(destination => destination.shouldUpdate(stageDestination))
            .forEach(destination => {
            destination.stages[stageName] = Object.assign({ [startHrTime]: now, "start": millisSinceStart, "status": "exception" }, stageMetadata);
        });
        return {
            end: (stageMetadata) => this.endStage(stageName, stageMetadata, stageDestination)
        };
    }
    // backdoor to add custom created stages
    [(_TimingEvent_logger = new WeakMap(), _TimingEvent_name = new WeakMap(), _TimingEvent_eventObject = new WeakMap(), _TimingEvent_metadata = new WeakMap(), _TimingEvent_loggingFunction = new WeakMap(), exports.addStage)](stageName, stage, metadataDestination) {
        this.destinations.filter(destination => destination.shouldUpdate(metadataDestination))
            .forEach(destination => {
            destination.stages[stageName] = stage;
        });
    }
    /**
     * Closes a stage within an event
     * @param {string} stageName - name of stage to close
     * @param {object} stageMetadata - Json object holding additional metadata for the closing of the stage
     * @param  {DESTINATION} stageDestination - the destinations which should be assigned with this stage and stageMetadata.
     * @default - if stageDestination not provided it defaults to DESTINATION.ALL
     */
    endStage(stageName, stageMetadata, stageDestination = "ALL" /* DESTINATION.ALL */) {
        let millisSinceTimingStartHrTime;
        this.destinations.filter(destination => destination.shouldUpdate(stageDestination))
            .forEach(destination => {
            const timing = destination.stages[stageName];
            if (timing) {
                if (!millisSinceTimingStartHrTime) {
                    // calc for first only as all should be the same while we want them to have same value
                    millisSinceTimingStartHrTime = millisSince(timing[startHrTime]);
                }
                timing["status"] = "complete";
                timing["duration"] = millisSinceTimingStartHrTime;
                if (stageMetadata) {
                    Object.assign(timing, stageMetadata);
                }
            }
        });
    }
    /**
     * Adds metadata to the event according to destination
     * @param {object} metadata - Json representing the metadata to add
     * @param {DESTINATION} destination - The destination of the metadata
     * @default if destination is not present defaults to DESTINATION.All
     */
    metadata(metadata, destination = "ALL" /* DESTINATION.ALL */) {
        this.destinations.forEach((dest) => {
            if (dest.shouldUpdate(destination)) {
                dest.data = Object.assign(Object.assign({}, dest.data), metadata);
            }
        });
    }
    /**
     * Ends an event with optional metadata
     * @param {Status} status - The status to close the event with (Example: "complete", "error"..)
     * @param {object} metadata - Optionally adding additional metadata when closing
     */
    end(status, metadata) {
        const duration = millisSince(this.timingStart);
        const events = {};
        this.destinations.forEach(destination => {
            const event = Object.assign(Object.assign({ event: __classPrivateFieldGet(this, _TimingEvent_name, "f") + "-end", component: __classPrivateFieldGet(this, _TimingEvent_name, "f"), duration: duration, status: status, stages: destination.stages }, destination.data), metadata);
            events[destination.name] = event;
            __classPrivateFieldGet(this, _TimingEvent_logger, "f").call(this, event, destination, __classPrivateFieldGet(this, _TimingEvent_loggingFunction, "f"));
        });
        return events;
    }
    /**
     * Ends an event with status: "complete" with optional metadata
     * @param {object} metadata - optional adding additional metadata when closing
     */
    complete(metadata) {
        return this.end("complete", metadata);
    }
    /**
     * Ends an event with status: "error" with optional metadata
     * @param {object} metadata - optional adding additional metadata when closing
     */
    completeWithError(metadata) {
        return this.end("error", metadata);
    }
    /**
     * Ends an event with a status based on the statusCode from the response (statusCode & body). Example response { statusCode: 200, body: "Success" }
     * @param {Response} response - A response object holding the statusCode and body attributes
     */
    endWithResponse(response) {
        const statusCode = response.statusCode || 200;
        const status = statusCode < 400 ? "complete" : "error";
        const msg = (status === "error") ? response.body : undefined;
        return this.end(status, { statusCode, msg });
    }
}
exports.TimingEvent = TimingEvent;
//# sourceMappingURL=timingEvent.js.map